// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"f1318d57effd1aa4","828":"60c3e9d40df4c336","931":"09b09a424b742539"}[chunkId] + ".css";
};